/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiService } from './services/api.service';
import { SubscriptionsService } from './services/subscriptions.service';
import { ProductsService } from './services/products.service';
import { PricesService } from './services/prices.service';
import { WebhookService } from './services/webhook.service';
import { CheckoutSessionsService } from './services/checkout-sessions.service';
import { CustomersService } from './services/customers.service';
import { TransactionsService } from './services/transactions.service';
import { PaymentSchedulingService } from './services/payment-scheduling.service';
import { AdminsService } from './services/admins.service';
import { EventsService } from './services/events.service';
import { ClinicsService } from './services/clinics.service';
import { ClinicDoctorsService } from './services/clinic-doctors.service';
import { PendingUsersService } from './services/pending-users.service';
import { DoctorsService } from './services/doctors.service';
import { DocumentsService } from './services/documents.service';
import { DocumentAccessLogsService } from './services/document-access-logs.service';
import { MediaService } from './services/media.service';
import { GoogleAuthService } from './services/google-auth.service';
import { GoogleCalendarAvailabilityService } from './services/google-calendar-availability.service';
import { GoogleCalendarEventsService } from './services/google-calendar-events.service';
import { UserWeeklyScheduleService } from './services/user-weekly-schedule.service';
import { UserWeeklyScheduleExceptionsService } from './services/user-weekly-schedule-exceptions.service';
import { UpdateAgendaService } from './services/update-agenda.service';
import { DoctorMatchingService } from './services/doctor-matching.service';
import { PathwaysService } from './services/pathways.service';
import { PhasesService } from './services/phases.service';
import { VisitsService } from './services/visits.service';
import { TestsService } from './services/tests.service';
import { PathwayTemplatesService } from './services/pathway-templates.service';
import { ClinicPathwaysService } from './services/clinic-pathways.service';
import { PatientsService } from './services/patients.service';
import { PsychosService } from './services/psychos.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiService,
    SubscriptionsService,
    ProductsService,
    PricesService,
    WebhookService,
    CheckoutSessionsService,
    CustomersService,
    TransactionsService,
    PaymentSchedulingService,
    AdminsService,
    EventsService,
    ClinicsService,
    ClinicDoctorsService,
    PendingUsersService,
    DoctorsService,
    DocumentsService,
    DocumentAccessLogsService,
    MediaService,
    GoogleAuthService,
    GoogleCalendarAvailabilityService,
    GoogleCalendarEventsService,
    UserWeeklyScheduleService,
    UserWeeklyScheduleExceptionsService,
    UpdateAgendaService,
    DoctorMatchingService,
    PathwaysService,
    PhasesService,
    VisitsService,
    TestsService,
    PathwayTemplatesService,
    ClinicPathwaysService,
    PatientsService,
    PsychosService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
